import { WrenchScrewdriverIcon } from '@heroicons/react/24/outline';
import { createFileRoute } from '@tanstack/react-router'

import { ErrorState } from '@/components/ui/states/ErrorState.tsx';
import Spinner from '@/components/ui/Spinner.tsx';
import DashboardHeader from '@/components/ui/layout/dashboard-layout/DashboardHeader.tsx';
import { Typography } from '@/components/ui/Typography.tsx';
import { crownQueryClient } from '@/common/api/crownQueryClient';
import { getProviderInfoQueryInfo } from '@/features/provider-panel/tools/api/providerInfoApi';
import { ProviderAdminTools } from '@/features/provider-panel/tools/ProviderAdminTools.tsx';

export const Route = createFileRoute('/provider/$providerId/tools/')({
  errorComponent: ErrorState,
  component: ProviderAdminTools,
  pendingComponent: () => (
    <div>
      <div
        className={
          'block w-full max-w-dashboard-content items-center gap-x-8 md:flex'
        }
      >
        <DashboardHeader>
          <WrenchScrewdriverIcon
            className={'mr-2 size-6 flex-none text-gray-800 md:size-8'}
          />
          Tools
        </DashboardHeader>
      </div>
      <div
        className={
          'flex h-96 w-full max-w-dashboard-content items-center justify-center'
        }
      >
        <Spinner className={'size-16'}/>
      </div>
      <Typography className={'invisible border p-4'}>
        You can generate and share the link with the customer to start the application for opening a deposit account.
      </Typography>
    </div>
  ),
  loader: async ({params}) =>
    crownQueryClient.ensureQueryData(getProviderInfoQueryInfo(params.providerId)),
});
